import angular from 'angular';
import Model from './model';
import AnalyticsServ from '../services/analytics';

function IssueFactory(Model, AnalyticsServ) {
	return class IssueModel extends Model {
		constructor(data = {}) {
			super(data);
			this.setApi("/case/:caseId/issue/:issueId", {
				caseId: '@caseId',
				issueId: '@id'
			}, {
				'list': {
					method: 'GET',
					url: '/case/:caseId/issues',
					isArray: true
				},
				'create': {
					method: 'POST',
					success: [
						data => this.setData(data),
						data => AnalyticsServ.added('Issue')
					]
				},
				'read': {
					method: 'GET'
				},
				'update': {
					method: 'PUT',
					success: [
						data => this.setData(data),
						data => AnalyticsServ.updated('Issue')
					]
				},
				'delete': {
					method: 'DELETE',
					success: [
						data => this.setData(data),
						data => AnalyticsServ.removed('Issue')
					],
					headers: {
						'x-lynx-confirmationCode': () => {
							return this.getData().confirmationCode;
						}
					},
					fail: [response => {
						this.data.confirmationCode = response.data.confirmationCode;
						this.fail(response);
					}]
				}
			});
		}
	}
}

IssueFactory.$inject = ['Model', 'AnalyticsServ'];

export default angular.module('models.issue', [Model, AnalyticsServ])
	.factory('Issue', IssueFactory)
	.name;



// WEBPACK FOOTER //
// ./project/models/issue.js